import { IconButton, Stack } from "@mui/material"
import { useState } from "react"
import FilterModal from "../modals/FilterModal"
import FilterAltRoundedIcon from "@mui/icons-material/FilterAltRounded"
import SortRoundedIcon from "@mui/icons-material/SortRounded"

const FilterSort = ({ data, fetch }) => {
  const [filterToggle, setFilterToggle] = useState("filter")
  const [showFilters, setShowFilters] = useState(false)
  const openFilters = (val) => {
    setFilterToggle(val)
    setShowFilters(true)
  }
  const closeFilters = () => setShowFilters(false)
  return (
    <>
      <Stack direction="row" spacing={1} marginBottom={1}>
        <IconButton onClick={() => openFilters("filter")}>
          <FilterAltRoundedIcon />
        </IconButton>
        <IconButton onClick={() => openFilters("sort")}>
          <SortRoundedIcon />
        </IconButton>
      </Stack>
      <FilterModal
        data={data}
        filterToggle={filterToggle}
        setFilterToggle={setFilterToggle}
        isOpen={showFilters}
        close={closeFilters}
        fetch={fetch}
      />
    </>
  )
}

export default FilterSort
